import React from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';
import RaisedButton from 'material-ui/RaisedButton';

import {
    Grid,
    Icon,
} from '../../components';
import {
    avaliadoresAreasService,
    avaliadoresProjetoService,
    projetoService,
    Utils,
} from '../../services';
import PrincipalMaster from '../master/Principal';
import InscricaoDetalhes from '../inscricao/InscricaoDetalhes';

class ProjetoInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dsAvaliadoresDisponiveis: [],
            dsAvaliadoresProjeto: [],
        };
    }

    async componentWillMount() {
        const avaliadoresDisponiveis = await avaliadoresAreasService.getAvaliadoresAreas(this.props.match.params.projeto);
        const avaliadoresProjeto = await avaliadoresProjetoService.getAvaliadoresProjeto(this.props.match.params.projeto);

        this.setState({
            dsAvaliadoresDisponiveis: avaliadoresDisponiveis,
            dsAvaliadoresProjeto: avaliadoresProjeto,
        });
    }

    async onDesclassificar() {
        if (window.confirm('Tem certeza que deseja desclassificar este trabalho? Esta ação é IRREVERSÍVEL.')) {
            try {
                const response = await projetoService.desclassificar({ codigo: this.props.match.params.projeto });
                Utils.showToast(response.message);
            } catch (e) {
                Utils.showToast(e.message);
            }
        }
    }

    async onNotificar() {
        if (window.confirm('Tem certeza que deseja notificar os avaliadores deste trabalho por e-mail?')) {
            try {
                const response = await avaliadoresProjetoService.notificarPorEmail(this.props.match.params.projeto);
                Utils.showToast(response.message);
            } catch (e) {
                Utils.showToast(e.message);
            }
        }
    }

    async addAvaliador(avaliador) {
        try {
            const projeto = this.props.match.params.projeto;
            // const _csrf = (await avaliadoresProjetoService.avaliadoresProjetoForm()).token;
            const response = await avaliadoresProjetoService.save({ projeto, avaliador });
            this.componentWillMount();
            Utils.showToast(response.message);
        } catch (e) {
            Utils.showToast(e.message);
        }
    }

    async delete(codigo, avaliou) {
        if (avaliou === 1) {
            alert("Ja fez sua avaliação... não pode excluí-lo mais!");
        } else
        if (window.confirm('Deseja excluir o avaliador do projeto?')) {
            try {
                const avaliador = codigo;
                const projeto = this.props.match.params.projeto;
                // const _csrf = (await avaliadoresProjetoService.avaliadoresProjetoForm()).token;
                const response = await avaliadoresProjetoService.delete({ projeto, avaliador });
                this.componentWillMount();
                Utils.showToast(response.message);
            } catch (e) {
                Utils.showToast(e.message);
            }
        }
    }

    render() {
        const {
            dsAvaliadoresDisponiveis,
            dsAvaliadoresProjeto,
        } = this.state;
        return (
            <PrincipalMaster title="Informações do Resumo/Projeto" {...this.props}>
                <InscricaoDetalhes codigoProjeto={this.props.match.params.projeto} />

                <div style={{ textAlign: 'center', paddingRight: 40 }}>
                    <RaisedButton
                        label="Desclassificar Resumo/Projeto"
                        backgroundColor="#de1f1fcc"
                        labelColor="#ffffff"
                        onClick={() => this.onDesclassificar()}
                    />
                </div>
                <hr />
                <div style={{ width: '100%', display: 'table' }}>
                    <div className="padding-content" style={{ width: '50%', display: 'table-cell', borderRight: 'solid 1px #ccc' }}>
                        <h3>Avaliadores Disponíveis </h3>


                        <Grid
                            ref={(ref) => { this.avaliadoresDisponiveisGridRef = ref; }}
                            stripedRows="true"
                            textTableEmpty="Nenhum avaliador disponível para esta área."
                            dataSource={dsAvaliadoresDisponiveis}
                            showSearch={false}
                            columns={[
                                {
                                    text: 'Nome', name: 'NOME', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                                },
                                {
                                    text: 'E-mail', name: 'EMAIL', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                                },
                                {
                                    text: 'Nº Projetos', name: 'NumProjetos', allowSort: true, allowSearch: true, searchOperator: 'LIKE', width: '100px',
                                },
                                {
                                    name: (item) => {
                                        return (
                                            <div>
                                                <IconButton tooltip="Adicionar" onClick={() => this.addAvaliador(item.PESSOAS_CODIGO)}>
                                                    <Icon color="#007744" name="arrow_forward" />
                                                </IconButton>
                                            </div>
                                        );
                                    },
                                    width: '50px',
                                },
                            ]}
                        />
                    </div>

                    <div className="padding-content" style={{ width: '50%', display: 'table-cell' }}>
                        <h3>Avaliadores Adicionados </h3>
                        <Grid
                            ref={(ref) => { this.avaliadoresDoProjetoGridRef = ref; }}
                            stripedRows="true"
                            textTableEmpty="Nenhum avaliador cadastrado para este projeto."
                            dataSource={dsAvaliadoresProjeto}
                            showSearch={false}
                            columns={[
                                {
                                    name: (item) => {
                                        return (
                                            <div>
                                                <IconButton tooltip="Excluir" onClick={() => this.delete(item.CODIGO, item.AVALIOU)}>
                                                    <Icon color="#de1f1fcc" name="arrow_back" />
                                                </IconButton>
                                            </div>
                                        );
                                    },
                                    width: '50px',
                                },
                                {
                                    text: 'Nome', name: 'NOME', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                                },
                                {
                                    text: 'E-mail', name: 'EMAIL', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                                },
                                {
                                    text: 'Avaliou', name: row => (row.AVALIOU === 1 ? 'Sim' : 'Não'), allowSort: true, allowSearch: true, searchOperator: 'LIKE', width: '100px',
                                },
                            ]}
                        />
                        <div style={{ textAlign: 'right' }} >
                            <RaisedButton
                                label="Notificar avaliadores por e-mail"
                                backgroundColor="#007744"
                                labelColor="#ffffff"
                                onClick={() => this.onNotificar()}
                            />
                        </div>
                    </div>
                </div>
            </PrincipalMaster>
        );
    }
}

ProjetoInfo.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            projeto: PropTypes.string.isRequired,
        }),
    }).isRequired,
};

export default ProjetoInfo;
